module.exports = __webpack_public_path__ + "assets/img/lb1.84a37093.jpg";